import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["leftContent", "leftContentMinWidth", "rightContent", "rightContentMinWidth"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { MIN_HEIGHT } from '../../../constants/nonTokenisedValues';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledHeaderDetails = styled.div.withConfig({
  displayName: "HeaderDetails__StyledHeaderDetails"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    marginLeft: `-${theme.space[600]}`,
    maxWidth: 'none',
    minHeight: MIN_HEIGHT.HEADER_DETAILS,
    padding: `0 ${theme.space[600]} 0 0`,
    width: `calc(100% + ${parseFloat(theme.space[600]) * 2}px)`
  }, $cssStyles);
});
const DetailsBox = styled.div.withConfig({
  displayName: "HeaderDetails__DetailsBox"
})(["flex-basis:", "px;flex-grow:", ";flex-shrink:", ";margin:", ";"], props => props.$basis, props => props.$grow, props => props.$shrink, ({
  theme
}) => `0 0 ${theme.space[400]} ${theme.space[600]}`);
export const HeaderDetails = _ref => {
  let {
      leftContent,
      leftContentMinWidth = 233,
      rightContent,
      rightContentMinWidth = 200
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledHeaderDetails, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'HeaderDetails',
    $cssStyles: cssStyles,
    children: [/*#__PURE__*/_jsx(DetailsBox, {
      $basis: leftContentMinWidth,
      $grow: 1,
      $shrink: 0,
      children: leftContent
    }), /*#__PURE__*/_jsx(DetailsBox, {
      $basis: rightContentMinWidth,
      $grow: 9999,
      $shrink: 1,
      children: rightContent
    })]
  });
};